import { Link } from 'react-router-dom';
import './RulesIndex.css';
import GuideHeader from './components/GuideHeader';

export default function RulesIndex() {
  return (
    <div className="rules-index-page">

      {/* ヘッダー */}
      <GuideHeader />

      <main>

        {/* HERO */}
        <section className="rules-index-hero">
          <div className="rules-index-container">

            <div className="rules-index-breadcrumb">
              <a href="/">トップ</a>
              <span>›</span>
              <span>ポーカーガイド</span>
            </div>

            <p className="rules-index-label">
              POKER GUIDE
            </p>

            <h1>
              ポーカーガイド
            </h1>

            <p className="rules-index-lead">
              ポーカーの各種ルールから、貸卓の使い方、
              仲間同士で遊ぶために必要な準備まで。
              初めての方にも分かりやすくまとめています。
            </p>

          </div>
        </section>

        {/* 各種ポーカールール */}
        <section className="guide-section">
          <div className="rules-index-container">

            <div className="guide-section-heading">
              <p>POKER RULES</p>
              <h2>各種ポーカールール</h2>

              <span>
                卓で見ながらすぐ遊べるように、
                基本ルールやゲームの流れをまとめています。
              </span>
            </div>

            <div className="poker-rules-grid">

              {/* NLH */}
              <Link
                to="/rules/nlh"
                className="poker-rule-card"
              >
                <div className="poker-rule-number">
                  01
                </div>

                <p className="poker-rule-en">
                  NO LIMIT TEXAS HOLD'EM
                </p>

                <h3>NLH</h3>

                <h4>
                  ノーリミット・テキサスホールデム
                </h4>

                <p className="poker-rule-description">
                  世界で最も広く遊ばれているポーカー。
                  手札2枚と最大5枚の共通カードを使って
                  最も強い5枚の役を作ります。
                </p>

                <div className="poker-rule-tags">
                  <span>手札2枚</span>
                  <span>初心者向け</span>
                  <span>ノーリミット</span>
                </div>

                <div className="guide-link">
                  ルールを見る →
                </div>
              </Link>

              {/* PLO */}
              <Link
                to="/rules/plo"
                className="poker-rule-card"
              >
                <div className="poker-rule-number">
                  02
                </div>

                <p className="poker-rule-en">
                  POT LIMIT OMAHA
                </p>

                <h3>PLO</h3>

                <h4>
                  ポットリミット・オマハ
                </h4>

                <p className="poker-rule-description">
                  手札4枚から必ず2枚、
                  ボードから必ず3枚を使って役を作るポーカー。
                  ホールデム経験者にも人気の種目です。
                </p>

                <div className="poker-rule-tags">
                  <span>手札4枚</span>
                  <span>2枚＋3枚</span>
                  <span>ポットリミット</span>
                </div>

                <div className="guide-link">
                  ルールを見る →
                </div>
              </Link>

              {/* 2-7 Triple Draw */}
              <div className="poker-rule-card is-coming">

                <div className="poker-rule-number">
                  03
                </div>

                <p className="poker-rule-en">
                  2-7 TRIPLE DRAW
                </p>

                <h3>2-7</h3>

                <h4>
                  2-7 トリプルドロー
                </h4>

                <p className="poker-rule-description">
                  弱い5枚の組み合わせを目指すドローポーカー。
                  カード交換を最大3回行います。
                </p>

                <div className="coming-badge">
                  COMING SOON
                </div>

              </div>

            </div>

          </div>
        </section>

        {/* 貸卓・遊び方ガイド */}
        <section className="guide-section rental-guide-section">
          <div className="rules-index-container">

            <div className="guide-section-heading">
              <p>RENTAL & PLAY GUIDE</p>

              <h2>
                貸卓・遊び方ガイド
              </h2>

              <span>
                ポーカースペースの使い方や、
                仲間同士でポーカーを始めるための情報をまとめています。
              </span>
            </div>

            <div className="rental-guide-grid">

  <Link
    to="/guide/akihabara-private-poker"
    className="rental-guide-card"
  >
    <span className="guide-category">
      秋葉原・神田
    </span>

    <h3>
      秋葉原で仲間だけで
      <br />
      ポーカーを遊ぶには？
    </h3>

    <p>
      アミューズメントポーカーとの違いや、
      仲間だけで遊べる方法、
      貸卓という選択肢を解説します。
    </p>

    <div className="guide-link">
      記事を見る →
    </div>
  </Link>

             <div className="rental-guide-card is-coming">
  <span className="guide-category">
    貸卓の基本
  </span>

  <h3>
    ポーカー貸卓とは？
    <br />
    料金・使い方・必要なもの
  </h3>

  <p>
    ポーカー貸卓の仕組みや料金、
    当日の利用方法、
    持ち物について分かりやすく解説します。
  </p>

  <div className="coming-badge">
    COMING SOON
  </div>
</div>

              <div className="rental-guide-card is-coming">
                <span className="guide-category">
                  6MAX
                </span>

                <h3>
                  6人でポーカーを遊ぶには？
                </h3>

                <p>
                  必要なもの、チップの準備、
                  ブラインドやゲームの進め方まで、
                  6人ポーカーの始め方をまとめます。
                </p>

                <div className="coming-badge">
                  COMING SOON
                </div>
              </div>

            </div>

          </div>
        </section>

        {/* CTA */}
        <section className="rules-index-cta">
          <div className="rules-index-container">

            <div className="rules-index-cta-inner">

              <div>
                <p className="rules-index-cta-small">
                  POKER RENTAL SPACE
                </p>

                <h2>
                  仲間だけで、
                  <br />
                  ポーカーを楽しもう。
                </h2>

                <p>
                  秋葉原・神田のポーカーレンタルスペース デュエル。
                  ポーカーテーブル・チップ・トランプを完備。
                  手ぶらでご利用いただけます。
                </p>
              </div>

              <div className="rules-index-cta-buttons">

                <a href="/#pricing">
                  料金を見る
                </a>

                <a
                  href="https://upnow.jp/duel"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="gold"
                >
                  空き状況を確認する
                </a>

              </div>

            </div>
          </div>
        </section>

      </main>
    </div>
  );
}